import { createSlice, PayloadAction } from "@reduxjs/toolkit"

interface ConversationMessage {
  responder_type: "user" | "assistant" | "system"
  content: string
  created_at?: number
  content_type?: string
  from_agent?: boolean
}

interface ConversationState {
  conversationMessages: ConversationMessage[]
  conversationId: string | null
  creatingConversation: boolean
  restartingConversation: boolean
}

const initialState: ConversationState = {
  conversationMessages: [],
  conversationId: null,
  creatingConversation: false,
  restartingConversation: false,
}

const conversationsStore = createSlice({
  name: "conversations",
  initialState,
  reducers: {
    setConversationMessages: (state, action: PayloadAction<ConversationMessage[]>) => ({
      ...state,
      conversationMessages: action.payload,
    }),
    appendConversationMessage: (state, action: PayloadAction<ConversationMessage>) => ({
      ...state,
      conversationMessages: [...state.conversationMessages, action.payload],
    }),
    setConversationId: (state, action: PayloadAction<string | null>) => ({
      ...state,
      conversationId: action.payload,
    }),
    setCreatingConversation: (state, action: PayloadAction<boolean>) => ({
      ...state,
      creatingConversation: action.payload,
    }),
    setRestartingConversation: (state, action: PayloadAction<boolean>) => ({
      ...state,
      restartingConversation: action.payload,
    }),
    resetConversation: () => initialState,
  },
})

export const {
  setConversationMessages,
  setConversationId,
  setCreatingConversation,
  appendConversationMessage,
  setRestartingConversation,
  resetConversation,
} = conversationsStore.actions

export default conversationsStore.reducer
